import { ArrowBackIcon } from '@chakra-ui/icons'
import { Heading, HStack, VStack, Box, Stack, Text } from '@chakra-ui/react'
import { useNavigate, useSearchParams } from 'react-router-dom'
import {
  useGetDeviceByIdQuery,
  useGetSensiboDeviceDataQuery,
} from '../api/dasboardApi'

import { PeriodTabStrip } from '../components/PeriodTabStrip'
import { DEVICEPARAMS } from '../consts'
import { useQueryParams } from '../hooks/useQueryParams'
import Header from '../../../app/components/Header'

import 'simplebar/dist/simplebar.min.css'
import React from 'react'
import { CLIMATE_CONTROL } from '../../../utils/consts'
import EnergyDeviceTitle from '../components/EnergyDeviceTitle'
import EnergyDeviceData from '../components/EnergyDeviceData'
import ClimateDeviceTitle from '../components/ClimateDeviceTitle'
import ClimateDeviceData from '../components/ClimateDeviceData'
import useRedirectOn404 from '../../../app/hooks/useRedirectTo404'

const DeviceDetails = () => {
  const [searchParams] = useSearchParams()
  const navigate = useNavigate()
  const [queryParams] = useQueryParams(DEVICEPARAMS)
  const deviceId = searchParams.get('device') || '0'

  const { data: currentDevice, error: getCurrentDeviceError, isFetching: isDeviceDataFetching } = useGetDeviceByIdQuery({
    id: deviceId,
  })


  const deviceReportResults =  []

  useRedirectOn404(getCurrentDeviceError, 'Device not found')

  const deviceCategory = currentDevice?.model?.type?.title

  const isClimateControl = currentDevice?.model?.type?.title === CLIMATE_CONTROL

  const { data: climateData, isFetching: isClimateDataFetching } =
    useGetSensiboDeviceDataQuery({ id: deviceId }, { skip: !isClimateControl })

  return (
    <Stack spacing={5}>
      <Header>
        <Heading as="h2" fontSize="2xl" fontWeight="bold">
          <Stack direction="row">
            <ArrowBackIcon
              _hover={{ cursor: 'pointer' }}
              onClick={() => {
                navigate(-1)
              }}
            />
            <Text>{currentDevice?.title}</Text>
          </Stack>
        </Heading>
      </Header>
      <Box w="full" p={6}>
        <VStack
          alignItems="flex-start"
          spacing={7}
          background="white"
          pt={4}
          pb={4}
          rounded="16px"
        >
          <Box w="full" px={6}>
            {isClimateControl ? null : <PeriodTabStrip />}
            <HStack spacing={0} w="full" mt={7}>
              <HStack spacing={8}>
                {isClimateControl ? (
                  <ClimateDeviceTitle
                    isDeviceDataFetching={isClimateDataFetching}
                    deviceData={climateData}
                  />
                ) : (
                  <EnergyDeviceTitle
                    isDeviceDataFetching={isDeviceDataFetching}
                    deviceData={{
                      category: currentDevice?.model?.type?.title,
                      id: currentDevice?.id,
                    }}
                  />
                )}
              </HStack>
            </HStack>
          </Box>
        </VStack>
        <Box mt={4}>
          {isClimateControl ? (
            <ClimateDeviceData deviceId={deviceId} />
          ) : (
            <EnergyDeviceData
              deviceCategory={deviceCategory}
              deviceReportData={deviceReportResults}
              isDeviceReportDataFetching={isDeviceDataFetching}
            />
          )}
        </Box>
      </Box>
    </Stack>
  )
}

export default DeviceDetails
